module.exports = __webpack_public_path__ + "static/media/deactiveeditDriver.381fba9f.svg";